/* eslint-disable react/prop-types */
import React from 'react';
import { setCurrencyFormat } from '../../../utils/helpers';

export const sortType = ((rowA, rowB, id, desc) => {
    let itemA = Number(rowA.original?.[id]?.toString().replace(/[&/\\#,+()$~%'":*?<>{}]/g, ''));
    let itemB = Number(rowB.original?.[id]?.toString().replace(/[&/\\#,+()$~%'":*?<>{}]/g, ''));

    if (Number.isNaN(itemA)) {  // Blanks and non-numeric strings to bottom
        itemA = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (Number.isNaN(itemB)) {
        itemB = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }

    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(itemA)) {
        if (itemA > itemB) return 1;
        if (itemB > itemA) return -1;
        // eslint-disable-next-line no-restricted-globals
    }

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(rowA.original?.[id])) {
        return rowA.original?.[id].localeCompare(rowB.original?.[id])
    }

    return 0;
})

export const tableHeaderCustomer = [
//     {
//     Header: 'Customer ID',
//     accessor: 'customerId',
//     disableGlobalFilter: false,
//     width: 130,
//     Cell: ({ cell: { row: { original } } }) => {
//         // eslint-disable-next-line react/prop-types
//         const { customerId } = original
//         return setCurrencyFormat(Number(customerId).toFixed(0), false)
//     },
//     sortType
// },
{
    Header: 'Company Name',
    accessor: 'companyName',
    disableGlobalFilter: false,
    width: 200,
    sortType
},
{
    Header: 'EmailId',
    accessor: 'email',
    disableGlobalFilter: false,
    width: 300,
    sortType
},
{
    Header: 'Name',
    accessor: 'fullName',
    disableGlobalFilter: false,
    width: 250,    
    sortType
},
{
    Header: 'Open Balance',
    accessor: 'openBalance',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { openBalance } = original
        return setCurrencyFormat(Number(openBalance).toFixed(2), true)
    },
    sortType
},
{
    Header: 'Phone',
    accessor: 'phone',
    disableGlobalFilter: false,
    width: 150,    
    sortType
},
{
    Header: 'Comments',
    accessor: 'comments',
    disableGlobalFilter: false,
    width: 700,    
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { comments } = original
        return <div className="wordwrap">{comments}</div>
    },    
    sortType
},
{
    Header: 'Shipping Address',
    accessor: 'shippingAddress',
    disableGlobalFilter: false,
    width: 300,   
    sortType
},
{
    Header: 'City',
    accessor: 'city',
    disableGlobalFilter: false,
    width: 130,    
    sortType
},
{
    Header: 'State',
    accessor: 'state',
    disableGlobalFilter: false,
    width: 100,   
    sortType
},
{
    Header: 'ZipCode',
    accessor: 'zipCode',
    disableGlobalFilter: false,
    width: 100,    
    sortType
},
{
    Header: 'Billing Address',
    accessor: 'billingAddress',
    disableGlobalFilter: false,
    width: 300,    
    sortType
},
{
    Header: 'Country',
    accessor: 'country',
    disableGlobalFilter: false,
    width: 100,    
    sortType
},
{
    Header: 'Date',
    accessor: 'createDate',
    disableGlobalFilter: false,
    width: 110,    
    sortType
},]

export const tableHeaderOrder = [
    {
        Header: 'Status',
        accessor: 'orderStatus',
        disableGlobalFilter: false,
        width: 150,        
        sortType
    },
    {
        Header: 'Internal ID',
        accessor: 'amazonOrderId',
        disableGlobalFilter: false,
        width: 170,
        Cell: ({ cell: { row: { original } } }) => {
          // eslint-disable-next-line react/prop-types
        const { amazonOrderId } = original
             return Number(amazonOrderId).toFixed(0)
         },
         sortType
    },
    {
        Header: 'Transaction Number',
        accessor: 'transactionNumber',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },
    {
        Header: 'Buyer Name',
        accessor: 'buyerName',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },
    // {
    //     Header: 'SKU',
    //     accessor: 'sku',
    //     disableGlobalFilter: false,
    //     width: 200,
    //     sortType
    // },
    // {
    //     Header: 'Product Name',
    //     accessor: 'productName',
    //     disableGlobalFilter: false,
    //     width: 250,    
    //     sortType
    // },
    {
        Header: 'Qty Shipped',
        accessor: 'quantityShipped',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { quantityShipped } = original
            return setCurrencyFormat(Number(quantityShipped).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Item Price',
        accessor: 'itemPrice',
        disableGlobalFilter: false,
        width: 120,  
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { itemPrice } = original
            return setCurrencyFormat(Number(itemPrice).toFixed(2), true)
        },  
        sortType
    },
    {
        Header: 'Currency',
        accessor: 'currency',
        disableGlobalFilter: false,
        width: 120,   
        sortType
    },
    // {
    //     Header: 'Carrier',
    //     accessor: 'carrier',
    //     disableGlobalFilter: false,
    //     width: 200,   
    //     sortType
    // },
    // {
    //     Header: 'Tracking Number',
    //     accessor: 'trackingNumber',
    //     disableGlobalFilter: false,
    //     width: 160,    
    //     sortType
    // },
    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 140,   
        sortType
    },
    {
        Header: 'Created Date',
        accessor: 'purchaseDate',
        disableGlobalFilter: false,
        width: 140,    
        sortType
    },
    // {
    //     Header: 'Shipment Date',
    //     accessor: 'shipmentDate',
    //     disableGlobalFilter: false,
    //     width: 140,    
    //     sortType
    // }
    ]

export const filterShowWiseForWholesaleOrders = [
    // {
    //     label: "All", value: "all"
    // }, 
    {
        label: "Pending Billing", value: "Pending Bill"
    },
    
    {
        label: "Partially Fulfilled", value: "Partially Fulfilled"
    },
    {
        label: "Pending Fulfillment", value: "Pending Fulfillment"
    },
    {
        label: "Pending Billing/Partially Fulfilled", value: "Pending Billing/Partially Fulfilled"
    },
    {
        label: "Closed", value: "Closed"
    },
    {
        label: "Billed", value: "Billed"
    },
    {
        label: "Cancelled", value: "Cancelled"
}]